import ApiService from "./ApiService";

export async function apiGetStarted(data) {
  return ApiService.fetchData({
    url: "/user/get-started",
    method: "post",
    data,
  });
}

export async function apiGetUserConfig(data) {
  return ApiService.fetchData({
    url: "/user/config",
    method: "get",
    data,
  });
}

export async function apiUpdateUserProfile(data) {
  return ApiService.fetchData({
    url: "/user/profile",
    method: "post",
    data,
  });
}
export async function apiUpdatePhone(params) {
  return ApiService.fetchData({
    url: "/user/profile/phone",
    method: "post",
    params,
  });
}

export async function apiUpdateUserEducation(data) {
  return ApiService.fetchData({
    url: "/user/education",
    method: "post",
    data,
  });
}

export async function apiUpdateUserAddress(data) {
  return ApiService.fetchData({
    url: "/user/address",
    method: "post",
    data,
  });
}

export async function apiUpdateUserFinancials(data) {
  return ApiService.fetchData({
    url: "/user/financials",
    method: "post",
    data,
  });
}

// Course interest tracking runs in the background, so a failure never shows the student a toast.
export async function apiSctTrack(data) {
  return ApiService.fetchData({
    url: "/public/course-info",
    method: "post",
    data,
    suppressErrorToast: true,
  });
}

export async function apiSctCourseView(data) {
  return ApiService.fetchData({
    url: "/public/course-views",
    method: "post",
    data,
    suppressErrorToast: true,
  });
}

export async function apiUploadDocument(data, options = {}) {
  return ApiService.fetchData({
    ...options,
    url: `/user/attachments`,
    method: "post",
    data,
  });
}

export async function apiRemoveDocument(data, options = {}) {
  return ApiService.fetchData({
    ...options,
    url: `/user/attachments/${data.attachmentType}`,
    method: "delete",
  });
}

// `options` takes ApiService flags such as `suppressErrorToast`.
export async function apiGetUploadedFiles(data, options = {}) {
  return ApiService.fetchData({
    url: `/user/attachments`,
    method: "get",
    data,
    ...options,
  });
}

export async function apiDeleteUploadedFiles(data) {
  return ApiService.fetchData({
    url: `/user/attachments`,
    method: "delete",
    data,
  });
}

export async function getProfile(data, options = {}) {
  return ApiService.fetchData({
    url: "/user/profile",
    method: "get",
    data,
    ...options,
  });
}

export async function getAttachmentConfigData(data, options = {}) {
  return ApiService.fetchData({
    url: "/user/attachment-config",
    method: "get",
    data,
    ...options,
  });
}

export async function getFinancials(data) {
  return ApiService.fetchData({
    url: "/user/financials",
    method: "get",
    data,
  });
}

export async function getAddress(data) {
  return ApiService.fetchData({
    url: "/user/address",
    method: "get",
    data,
  });
}
export async function getEducation(data) {
  return ApiService.fetchData({
    url: "/user/education",
    method: "get",
    data,
  });
}

export async function apiGetAccountSettingData() {
  return ApiService.fetchData({
    url: "/account/setting",
    method: "get",
  });
}

export async function apiGetAccountSettingIntegrationData() {
  return ApiService.fetchData({
    url: "/account/setting/integration",
    method: "get",
  });
}

export async function apiGetAccountSettingBillingData() {
  return ApiService.fetchData({
    url: "/account/setting/billing",
    method: "get",
  });
}

export async function apiGetAccountInvoiceData(params) {
  return ApiService.fetchData({
    url: "/account/invoice",
    method: "get",
    params,
  });
}

export async function apiGetAccountLogData(data) {
  return ApiService.fetchData({
    url: "/account/log",
    method: "post",
    data,
  });
}

export async function apiGetAccountFormData() {
  return ApiService.fetchData({
    url: "/account/form",
    method: "get",
  });
}

export async function apiGetRenderFormById(data) {
  const { id } = data;
  return ApiService.fetchData({
    url: `/user/forms/${id}`,
    method: "get",
  });
}
export async function apiGetPublicRenderFormById(data) {
  const { id } = data;
  return ApiService.fetchData({
    url: `/forms/${id}`,
    method: "get",
  });
}
export async function apiUploadFile(data, options = {}) {
  return ApiService.fetchData({
    ...options,
    url: `/user/file/upload`,
    method: "post",
    data,
  });
}
